/* istanbul ignore file */



import React from 'react';







import { DATA_TABLE_TREE_STYLE_TYPE } from '../../../../common/constants/dataTableTreeStyleType';






































// $FlowFixMe
export const DataTableContext = React.createContext({
  sort: null,
  hasData: false,
  hasTreeData: false,
  treeRowsNodes: [],
  treeStyleType: DATA_TABLE_TREE_STYLE_TYPE.SIMPLE,
  onSortChange: () => {},
  onRowExpandChange: () => {}
});